export default "__VITE_ASSET__e8b91c67__"